import React from 'react';
import { Box, Typography } from '@mui/material';

export function VideoCarouselEmptyState() {
  return (
    <Box
      sx={{
        py: 6,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        bgcolor: 'grey.50',
        borderRadius: 3,
      }}
    >
      <Typography variant="body1" color="text.secondary">
        Inga videokaruseller skapade än
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Klicka på &quot;Skapa ny karusell&quot; för att komma igång
      </Typography>
    </Box>
  );
}
